// extracted by mini-css-extract-plugin
export default {"lead_generate_t1":"InputBaseCust_lead_generate_t1__s90FK"};